<template>
  <main id="selecionar-empresa" class="ohx login-modal">
    <v-content class="ohx">
      <v-container fluid grid-list-xs class="white-background ohx pb-4">
        <v-layout row wrap>
          <v-flex xs12 v-if="!emailSent">
            <h2 class="title">Recuperar Senha</h2>
            <span class="close-button" @click.prevent="close()"
              ><v-icon>close</v-icon></span
            >

            <p class="description">
              Insira seu E-mail para localizarmos a sua conta
            </p>
            <v-form ref="form" v-model="valid">
              <v-layout row wrap>
                <v-flex xs12>
                  <v-text-field
                    class="form-input-box mt-4 mb-0 pb-0 email-input lowercase"
                    label="E-mail"
                    v-model="model.email"
                    :rules="emailRules"
                    placeholder=" "
                  ></v-text-field>
                </v-flex>
                <v-flex xs4 offset-xs8>
                  <button
                    class="button jns-button yellow-button mt-5"
                    :disabled="!valid"
                    @click.prevent="sendRecoveryPasswordMail()"
                  >
                    Enviar
                  </button>
                </v-flex>
              </v-layout>
            </v-form>
          </v-flex>
          <v-flex xs12 v-if="emailSent">
            <h2 class="title">{{ feedback.title }}</h2>
            <p class="description">{{ feedback.message }}</p>
            <v-layout row wrap>
              <v-flex xs4 offset-xs8>
                <button
                  class="button jns-button yellow-button mt-5"
                  @click.prevent="close()"
                >
                  OK
                </button>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </main>
</template>

<style lang='scss' scoped>
#jns {
  .description {
    color: #191737;
    font-size: 16px;
  }
  .title {
    font-weight: bold;
    display: inline-block;
    margin-bottom: 10px;
    color: #191737;
  }
  .white-background {
  }
  .close-button {
    float: right;
    margin-top: -5px;
    cursor: pointer;
  }
}
</style>

<script lang="js">
import ViewMixin from "@/mixins/ViewMixin";

export default {
  name: "RecuperarSenhaModal",
  mixins: [ViewMixin],
  data: () => ({
    alertText: false,
    emailSent: false,
    model: {},
    valid: true,
    emailRules: [
      (v) => !!v || "É necessário fornecer um E-mail",
      (v) => /.+@.+/.test(v) || "E-mail deve ser válido!",
    ],
  }),

  computed: {
    filteredItems() {},
  },
  methods: {
    async sendRecoveryPasswordMail() {
      let t = this;
      let response;
      t.model.email = t.model.email.toLowerCase();
      t.showLoadingIndicator();
      try {
        response = await t.$store.dispatch("SEND_RECOVERY_PASSWORD_EMAIL", {
          email: t.model.email,
        });
      } catch (e) {
        if (e.status == 404) {
          t.hideLoadingIndicator();
          t.feedback = {
            title: e.data.title,
            message: e.data.message,
          };
          t.model.email = "";
          t.emailSent = true;
          return;
        }
      }
      t.feedback = {
        title: "Recuperar Senha",
        message: "E-mail enviado com sucesso, cheque sua caixa de entrada.",
      };
      t.hideLoadingIndicator();
      t.model.email = "";
      t.emailSent = true;
    },
    close() {
      let t = this;
      t.$emit("close");
      setTimeout(() => {
        t.emailSent = false;
      }, 1000);
    },
  },

  
  props: ["companies"],
};
</script>





// WEBPACK FOOTER //
// ./src/components/RecuperarSenhaModal.vue